import React from "react"
import cx from "classnames"

export interface NoteProps {
  children: React.ReactNode
  /**
   * will fill available width
   * @default false
   */
  fullWidth?: boolean
  className?: string
  isError?: boolean
}

export const Note = ({
  children,
  fullWidth = false,
  className,
  isError = false,
}: NoteProps) => (
  <div
    className={cx("cobalt-Note", className, {
      "cobalt-Note--fullWidth": fullWidth,
      "cobalt-Note--error": isError,
    })}
  >
    {children}
  </div>
)

export default Note
